import { fetchpayment } from "@/api/merchant/request.post";
import { numberSeparator,  toEnglishNumber,  toPersianNumber } from "@/hooks/useThousandsSeparator";
import LoadingButton from "@/shared/components/common/loadingButton";
import ImgSliderBox from "@/shared/components/common/sliderControl";
import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { InputAdornment, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import CardBoxLayout from "../../layout/cardBoxLayout";
/**
 * Content
 *
 * کامپوننت مدیریت شارژ کیف پول اعتباری کاربر.
 * این کامپوننت شامل:
 * - نمایش توضیحات بالایی درباره شارژ کیف پول
 * - فیلد ورودی مبلغ با اعتبارسنجی و فرمت فارسی
 * - انتخاب درگاه پرداخت با استفاده از اسلایدر
 * - نمایش سقف واریز روزانه و اطلاعات درگاه انتخاب شده
 * - دکمه ادامه برای ثبت تراکنش
 *
 * ویژگی‌های واکنش‌گرا:
 * - جهت‌دهی و چینش عناصر در موبایل به صورت ستونی
 * - ورودی مبلغ و دکمه‌ها با عرض 100% در صفحه‌های کوچک
 * - اسلایدر درگاه در موبایل وسط‌چین شده
 * - متن‌ها راست‌چین و وسط‌چین بر اساس سایز صفحه
 *
 * استفاده از:
 * - react-query برای ارسال درخواست
 * - toast برای نمایش خطاها
 * - MUI برای فیلدهای ورودی و ظاهر کلی
 *
 * @returns JSX.Element
 */
const Content = () => {
  const { mutate: submitFormGiftPazirandeBar, isPending } = useMutation({
    mutationFn: (body: any) => fetchpayment(body),
    onSuccess: (data: any) => {
      window.location.href = data?.data?.url;
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
    },
  });

  const sampleColors = [
    { id: "1", color: "#10b981" },
    { id: "2", color: "#f59e0b" },
    { id: "3", color: "#ef4444" },
    { id: "4", color: "#3b82f6" },
  ];

  const [step, setStep] = React.useState(0);
  const handleNextStep = (id: number) => {setStep(id);};
  const [amountState, setAmountState] = useState("");

  const [selectedImage, setSelectedImage] = useState<any>({ id: 1, title: "fanava", img: "/fanavar.png", name: "فن آوا" });
  const arrayImage = [
    { id: 1, title: "fanava", img: "/fanavar.png", name: "فن آوا" },
    // { id: 2, title: "aap", img: "/aap.png", name: "آپ" },
    // { id: 3, title: "vandar", img: "/vandar2.png", name: "وندار" },
    // { id: 4, title: "pariz", img: "/pariz.png", name: "پاریزپی" },
  ];

  const onSubmit = () => {
    const requestBody = {
      payment_type_id: 4,
      gateway: selectedImage?.title,
      fee: amountState,
    };
    submitFormGiftPazirandeBar(requestBody);
  };

  return (
    <CardBoxLayout sx={{display:'flex', flexDiraction:'column', width: "100% !important", justifyContent: "space-around", gap: { xs: 3, }, padding: 2,}}>
        {/* Top Description */}
        <BoxKit sx={{ width: "100%", display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}>
          <TypoGraphyKit variant="body1" sx={{ textAlign: { xs: "center", md: "left" } }}>
            شما در حال شارژ موجودی نقدی کیف پول اعتباری خود هستید.
          </TypoGraphyKit>
        </BoxKit>

        {/* Amount Input */}
        <StackKit direction={{ xs: "column", sm: "row" }} sx={{ width: "100%" }} justifyContent="space-between" alignItems={{ xs: "stretch", sm: "center" }} gap={2}>
          <TypoGraphyKit variant="body1" sx={{ textAlign: { xs: "center", sm: "left" } }}>
            مبلغ مورد نظر را وارد نمایید (ریال)
          </TypoGraphyKit>

          <TextField fullWidth sx={{width: { xs: "100%", sm: "60%" },"& input": { textAlign: "center" },}} placeholder={`${numberSeparator(20000000)}`}
            value={amountState ? `${toPersianNumber(numberSeparator(amountState))}` : ""}
            onChange={(e) => {
              const englishNumber = toEnglishNumber(e.target.value);
              const rawValue = englishNumber.replace(/[^0-9]/g, "");
              if (Number(rawValue) <= 10000000000) {
                setAmountState(rawValue);
              }
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">ریال</InputAdornment>,
            }}
          />
        </StackKit>

        {/* Gateway Selection */}
        <StackKit direction="column" sx={{ width: "100%", gap: 2, alignItems: "center", justifyContent:'center' }}>
          <TypoGraphyKit variant="body1" sx={{ textAlign: { xs: "center", md: "right" }, width: "100%" }}>
            در صورت تمایل درگاه مورد نظر خود را انتخاب نمایید
          </TypoGraphyKit>

          <BoxKit className="w-full flex " justifyContent={'center'} alignItems={'center'}>
            <ImgSliderBox className="w-full max-w-[450px] mx-auto" imageList={arrayImage} setSelectedImage={setSelectedImage}/>
          </BoxKit>
        </StackKit>


        {/* Bottom Info + Button */}
        <StackKit direction={{ xs: "column", md: "row" }} sx={{ width: "100%" }} justifyContent="space-between" alignItems={{ xs: "stretch", md: "center" }} gap={3} flexWrap="wrap">
          <StackKit direction={{ xs: "column", sm: "row" }} alignItems="center" justifyContent={{ xs: "center", sm: "flex-end" }} gap={2} sx={{ width: "100%" }} flexWrap="wrap">
            <StackKit direction={{ xs: "column", sm: "row" }} gap={2} alignItems="center" flexWrap="wrap">
              <TypoGraphyKit variant="body1" sx={{textAlign: { xs: "center", sm: "left" },}}>
                درگاه پرداخت انتخاب شده: {selectedImage.name}
              </TypoGraphyKit>
              {selectedImage?.img && (
                <BoxKit sx={{ width: { xs: "80px", sm: "100px" }, height: { xs: "50px", sm: "70px" }, bgcolor: "white", overflow: "hidden", borderRadius: "8px",}}>
                  <img src={selectedImage?.img} alt="selected-gateway" className="w-full h-full object-cover rounded-[8px]" />
                </BoxKit>
              )}
            </StackKit>
            <LoadingButton onSubmit={onSubmit} title="ادامه" isPending={isPending}/>
          </StackKit>
        </StackKit>
        <TypoGraphyKit variant="body1" sx={{ color: "#666666", textAlign: { xs: "center", md: "right" }, width: { xs: "100%", md: "auto" },}}>
          سقف واریز روزانه: {numberSeparator(50000000)} ریال
        </TypoGraphyKit>
    </CardBoxLayout>

  );
};

export default Content;
